import { Trans } from '@mc/i18n'
import { usePromotion } from '@mc/promo-utils'
import { useStaticData } from '@mc/static-data-react'
import { type StaticData } from 'types/libs/staticData'
import { EXPERIMENT_I18N_NAMESPACE } from '../i18n'

export const PriceLine = () => {
  const { annualPass } = useStaticData<StaticData>()
  const { isPromotionOn } = usePromotion()

  if (!annualPass) return null

  const price = annualPass.monetizedYearPricePerMonth
  const discountedPrice = annualPass.monetizedYearPricePerMonthDiscounted
  const hasDiscountedPrice = isPromotionOn && !!discountedPrice

  return (
    <p className='mc-text-x-small mc-opacity--muted mc-mb-0'>
      <Trans
        ns={EXPERIMENT_I18N_NAMESPACE}
        i18nKey={
          hasDiscountedPrice ? 'priceLine.discount' : 'priceLine.regular'
        }
        values={
          hasDiscountedPrice
            ? { strikeThroughPrice: price, price: discountedPrice }
            : { price }
        }
        components={{
          bold: <span className='mc-text--bold' />,
          strike: <span className='mc-text--strike' />,
        }}
      />
    </p>
  )
}
